import getUUID from '@gcloud-npm/utils.monitoring.get-uuid';
import Sonda from '@gcloud-npm/utils.monitoring.sonda';
import Request from '@gcloud-npm/utils.request';
import calculateHeaderParams from '@gcloud-npm/node.build-process.build-environments';
import { HOST, PROCESS_NAME, FAMILY_API } from './constants';

const PATH =
  '/movistar-layer/api/open/appointment/v1/installation/purchase/get-slots';
const EVENT_NAME = 'BAF.APPOINTMENT';
const appointment = ({
  params,
  data,
  context,
  idFront = 'VT',
  build = false,
}) => {
  const idRequest = getUUID(idFront);
  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME,
  });
  const paramsString = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');
  const URL_API = `https://layer.col.movistar.es${PATH}?${paramsString}`;
  const headers2Use = calculateHeaderParams(build, FAMILY_API, context);
  const request = new Request({
    method: 'POST',
    endpoint: URL_API,
    headers: {
      ...headers2Use,
      'Content-Type': 'application/json',
    },
    sonda,
    data,
  });
  return request.makeRequest();
};
export default appointment;
